import type { ReactNode } from 'react';
import { Icon3D, type Icon3DName } from '@/components/Icon3D';

export function PageHeader({ title, description, actions, back, icon }: {
  title: ReactNode; description?: ReactNode; actions?: ReactNode; back?: ReactNode; icon?: Icon3DName;
}) {
  return (
    <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div className="flex min-w-0 items-center gap-3">
        {icon ? <Icon3D name={icon} size={52} eager className="hidden sm:block" /> : null}
        <div className="min-w-0">
          {back}
          <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
          {description ? <p className="mt-1 text-[15px] text-ink-2">{description}</p> : null}
        </div>
      </div>
      {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
    </div>
  );
}
